import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import React from 'react';

// TODO: After QA / launch, move these scripts to index.html. They're being loaded in the app itself to start, in order to allow access to Feature Flag context
export const AddTrustArcScript: React.FC<React.PropsWithChildren<unknown>> = () => {
  const mockUK = useFeatureFlag('TRUSTARC_MOCK_UK');
  const mockCA = useFeatureFlag('TRUSTARC_MOCK_CA');

  // If flag enabled, load the main TrustArc script
  React.useEffect(() => {
    // Main script
    const mainScript = document.createElement('script');

    mainScript.setAttribute('type', 'text/javascript');
    mainScript.setAttribute(
      'src',
      `//consent.trustarc.com/notice?domain=exploretock.com&c=teconsent&js=nj&noticeType=bb&gtm=1&text=true${
        mockUK ? '&country=gb' : mockCA ? '&country=us&state=ca' : ''
      }`
    );
    mainScript.setAttribute('async', 'async');
    mainScript.setAttribute('crossorigin', '');

    const head = document.getElementsByTagName('head')[0];
    head.insertBefore(mainScript, head.firstChild);
  }, [mockCA, mockUK]);

  return null;
};
